"use client";

type SubtitleProps = {
  color?: string;
  children?: React.ReactNode;
  fontSizeWeight?: string;
};

const CommonSubtitle = ({
  color = "#202020",
  children,
  fontSizeWeight = "text-[14px] lg:text-[16px] font-normal",
}: SubtitleProps) => {
  return (
    <p
      style={{
        color: color,
      }}
      className={`text-[14px] font-normal lg:text-[16px] ${fontSizeWeight}`}
    >
      {children}
    </p>
  );
};

export default CommonSubtitle;
